import { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Alert,
  LinearProgress,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AuthContext from '../AuthContext';
import { apiFetch } from '../api';

export default function AdminLogsPage() {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState(null);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await apiFetch('/api/admin/logs/', {
          headers: token ? { Authorization: `Token ${token}` } : {},
        });
        if (!response.ok) {
          throw new Error('Failed to fetch logs');
        }
        const data = await response.json();
        setLogs(data);
      } catch (err) {
        setError(err.message);
      }
    };
    if (token) {
      fetchLogs();
    }
  }, [token]);

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (logs.length === 0) {
    return (
      <Container sx={{ py: 4 }}>
        <LinearProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Admin Logs
      </Typography>
      <List>
        {logs.map((log) => (
          <ListItem key={log.id} alignItems="flex-start">
            <ListItemText
              primary={log.visible_name || log.file.split('/').pop()}
              secondary={`Status: ${log.status}`}
            />
            <Button
              component={RouterLink}
              to={`/admin/logs/${log.id}`}
              variant="outlined"
              size="small"
            >
              Review
            </Button>
          </ListItem>
        ))}
      </List>
    </Container>
  );
}
